import request from 'sb-request'
import actions from 'redux/actions'
import { reducers, getState } from 'redux/core'
import { mixpanel, constants } from 'common/helpers'

import { getPrefixedAddressFields } from 'common/helpers/getters'


/**
 *
 * @param {object} values
 * @param {object} values.shipping
 * @param {string} values.shipping.firstName
 * @param {string} values.shipping.lastName
 * @param {string} values.shipping.street
 * @param {string} values.shipping.zipCode
 * @param {string} values.shipping.country
 * @param {string} values.shipping.city
 * @param {string} values.shipping.state
 * @param {string} values.code
 * @param {string} values.token
 * @returns {*}
 */
const redeemGiftSubscription = (values) => {
  const { models: { requestTokens: { redeemGiftSubscription: token } } } = getState()
  const { shipping, code } = values

  mixpanel.track(constants.analyticsEvents.tech.redeemGiftSubscription)

  const body = {
    ...getPrefixedAddressFields({ shipping }),
    code,
    token,
  }

  return request.post('rest/gift/subscription/redeem', {
    body,
  })
    .then(() => {
      reducers.models.me.activateGiftSubscription()
      // TODO remove 'giftData' then all pages will be moved to new react app
      actions.misc.cookies.removeItem('giftData')
    })
}


export default redeemGiftSubscription
